<template>
  <div>
  	<h3 class="text-warning">
  		<i class="fa fa-exclamation-triangle text-danger"></i> UNDER CONSTRUCTION
  	</h3>
  </div>
</template>

<script>
export default {
  name: 'DefaultAside'
}
</script>
